export const AUTH_REQUEST = "AUTH_REQUEST"
export const AUTH_SUCCESS  = "AUTH_SUCCESS"
export const AUTH_FAILURE = "AUTH_FAILURE"
export const SIGNUP_REQUEST = "SIGNUP_REQUEST"
export const SIGNUP_SUCCESS  = "SIGNUP_SUCCESS"
export const SIGNUP_FAILURE = "SIGNUP_FAILURE"
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS"